<div class="skeleton-container" (click)="cta()">
  <div class="skeleton-container__photo"></div>
  <div class="skeleton-container__info">
    <span class="skeleton-title"></span>
    <span class="skeleton-author"></span>
    <div class="cta">
      <opac-icon icon="add_circle" size="2x"></opac-icon>
      <span>{{ 'add.new.content' | translate }}</span>
    </div>
    <div class="skeleton-button"></div>
  </div>
</div>
